<template>
  <div class="input-wrap">
    <input type="radio"
           :id="radioLabel"
           :name="radioName"
           :value="inputValue"
           v-model="model">
    <label :for="radioLabel"><slot /></label>
  </div>
</template>

<script>
export default {
  name: 'UiRadio',
  props: {
    radioText: {
      type: String,
      default: ''
    },
    radioLabel: {
      type: String,
      default: ''
    },
    radioName: {
      type: String,
      default: 'name'
    },
    value: {},
    inputValue: { },
    index: {},
    parentIndex: {}
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value, this.index, this.parentIndex, 'radio')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-wrap {
    margin-top: 25px;
    padding-left: 30px;
    label {
        display: inline-block;
        padding: 0 0 0 30px;
        background: url('../../assets/img/icon-radio.svg') no-repeat left top 1px;
        font-size: 14px;
        line-height: 1.57;
        color: #444;
        cursor: pointer;
    }
    input[type=radio] {
        display: none;

        &:checked + label {
            background: url('../../assets/img/icon-radio-on.svg') no-repeat left top 1px;
        }
    }
}

@media all and (max-width: 768px) {
    .input-wrap {
        padding-left: 0px;
    }
}
</style>
